/**
 * Truncates text to a maximum length with ellipsis.
 *
 * Used to ensure long usernames or location names fit on the 3×7cm label.
 *
 * @param text - The text to truncate
 * @param maxLength - Maximum length before truncation (default: 30)
 * @returns Truncated text with ellipsis if needed
 *
 * @example
 * truncateText('Very Long Username That Will Not Fit', 20)
 * // Returns: 'Very Long Username...'
 */
export function truncateText(text: string, maxLength: number = 30): string {
    if (text.length <= maxLength) {
        return text;
    }
    return text.substring(0, maxLength - 3) + '...';
}

/**
 * Calculates the number of A4 sheets needed for a given label count.
 *
 * Each A4 sheet holds 24 labels in a 3×8 grid layout.
 *
 * @param totalLabels - The total number of labels to print
 * @returns Number of A4 sheets required
 *
 * @example
 * calculateLabelSheets(30)
 * // Returns: 2 (24 on first sheet, 6 on second sheet)
 */
export function calculateLabelSheets(totalLabels: number): number {
    const LABELS_PER_SHEET = 24;
    return Math.ceil(totalLabels / LABELS_PER_SHEET);
}
